import { type EditorPlugin } from '../../types/aha-editor';
import { type Editor, type NodeEntry, Text, Transforms } from 'slate';
import { isLinkElement } from '../../types/guards';

// Normalize link elements.
// 1. A link with no visible text should be removed since the user can no longer
//    easily navigate it, and it can't be clicked.
// 2. A link must have a 'link_href' property. If it's null or undefined, set
//    it to an empty string.
const LinkNormalizationPlugin: EditorPlugin = {
  name: 'Link normalization plugin',
  normalizations: [
    {
      type: 'link',
      run: (editor: Editor, entry: NodeEntry) => {
        const [node, path] = entry;

        if (!isLinkElement(node)) return;

        if (
          node.children.length === 1 &&
          Text.isText(node.children[0]) &&
          node.children[0].text === ''
        ) {
          Transforms.removeNodes(editor, { at: path });
          return true;
        }
      },
    },
    {
      type: 'link',
      run: (editor: Editor, entry: NodeEntry) => {
        const [node, path] = entry;

        if (!isLinkElement(node)) return;

        if (typeof node.link_href === 'undefined' || node.link_href === null) {
          Transforms.setNodes(editor, { link_href: '' }, { at: path });
          return true;
        }
      },
    },
  ],
};

export default LinkNormalizationPlugin;
